const { COMPANY_NAME } = require("./constants");

const developmentCompanyIds = {
    "5c60469aff5cd815748df923": COMPANY_NAME.HTZ,
    "6693dc362a605ba17f95b265": COMPANY_NAME.HTZ,
    "6673303c5e9606512f6b47de": COMPANY_NAME.RN,
    "667bbca297a422cbd5abfa9b": COMPANY_NAME.LS,
}

const productionCompanyIds = {
    "6704e871022c6aec954dc5a3": COMPANY_NAME.HTZ,
    "670b89f5eff567d71ceff4fb": COMPANY_NAME.RN,
    "66f2bf384d1a7164b76fb307": COMPANY_NAME.LS,
    "6836e1eed06cc5a8f687d80d": COMPANY_NAME.LS,
}

module.exports = {
    ...developmentCompanyIds,
    ...productionCompanyIds,
}